import { MenuItem } from '@mui/material';
import { CustomSelect, CustomTextField, HeaderFilterBox } from '../../../common';

const UpdateDebtFilters = ({ filter, handleFilter, plans, groups }) => {
  const filterStyles = {
    ml: { xs: 0, md: 2 },
    mt: 0,
    width: { xs: '100%', sm: '48%', md: '15%' },
    mb: { xs: 1, md: 0 },
  };

  return (
    <HeaderFilterBox>
      <CustomSelect
        label="Plan"
        labelId="plan-label"
        id="plan-select"
        name="plan"
        value={filter.plan}
        onChange={handleFilter}
        sx={filterStyles}
        size="medium"
      >
        {plans.map((plan) => (
          <MenuItem key={plan.uuid} value={plan.uuid}>
            {plan.name}
          </MenuItem>
        ))}
      </CustomSelect>

      <CustomSelect
        label="Grupo"
        labelId="group-label"
        id="group-select"
        name="group"
        value={filter.group}
        onChange={handleFilter}
        displayEmpty
        sx={filterStyles}
        size="medium"
      >
        <MenuItem value="">Todos</MenuItem>
        {groups.map((group) => (
          <MenuItem key={group.uuid} value={group.uuid}>
            {group.name}
          </MenuItem>
        ))}
      </CustomSelect>

      <CustomTextField
        label="Orden"
        id="contract_number-input"
        name="contract_number"
        value={filter.contract_number}
        onChange={handleFilter}
        sx={filterStyles}
        size="medium"
      />
    </HeaderFilterBox>
  );
};

export default UpdateDebtFilters;